import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import Button from "_shared/components/Button/Button";
import "../register/Register.scss";
import { FormValues } from "../_shared/models/FormValues";
import { ProductDetails } from "../_shared/models/ProductDetails";
import addons from "./constants/addOns";
import styles from "./SelectAddOns.module.scss";

// TODO: there's inconsistency between casing -- addons vs addOns

interface Props {
  productDetails: Record<string, ProductDetails>;
  onBack: () => void;
  onNext: () => void;
}

const SelectAddOns: React.FC<Props> = ({ productDetails, onBack, onNext }) => {
  const [totalPrice, setTotalPrice] = useState(0);

  const { values, setFieldValue } = useFormikContext<FormValues>();
  const setSelectedAddons = (newVal: string[]) =>
    setFieldValue("addOns", newVal);

  //Select Add-On Plans and Price Id's to charge correct amount on Stripe once submitted.
  const newAddons = async (i: number, id: string) => {
    // addon is already in the list
    if (values.addOns.find((addon) => addon === id)) {
      setSelectedAddons(values.addOns.filter((addon) => addon !== id));
      // addon is not in the list
    } else {
      setSelectedAddons([...values.addOns, id]);
    }
  };

  // update total price
  useEffect(() => {
    const addonTotal = values.addOns.reduce((prev, addonId: string) => {
      // get price for addon plan (daily or intraday -- top25 is only daily)
      const price =
        productDetails[addonId][
          `monthly_${
            addonId === "top25_dashboard" ? "daily" : values.frequency
          }_price`
        ];
      return prev + price;
    }, 0);
    setTotalPrice(addonTotal);
  }, [productDetails, values.addOns, values.frequency]);

  return (
    <div className={styles.container}>
      <div className="card add-on-card">
        <div>
          <h2 className={styles.welcomeText}>Select Add-Ons</h2>
          <div>
            <div className="add-ons-styles">
              <div className="column">
                {/* TODO: these classes are in the signup css file and should be split into a module */}
                <div className="add-ons-table">
                  <br />
                  <br />
                  {addons.map((addon, i) => (
                    <div
                      key={addon.id}
                      className="asset-info-row"
                      data-testid={`addonrow-${addon.id}`}
                    >
                      <div className="addons-cell first-cell">
                        <p
                          style={{
                            fontSize: ".9rem",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {`${addon.name} \n `}
                          <span
                            style={{
                              color: "#75CE41",
                              fontSize: "1rem",
                            }}
                          >
                            {/* TODO: these prices are not from api but from the hardcoded addons file */}
                            {values.frequency === "daily" ||
                            addon.name === "Top 25"
                              ? `$${addon.price}/month`
                              : `$${addon.price * 2}/month`}
                          </span>
                        </p>
                        {addon.name === "Top 25" && (
                          <p>Only available as a daily add-on</p>
                        )}
                      </div>
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          alignContent: "center",
                        }}
                        className="addons-cell"
                      >
                        {addon.description}
                        {addon.selected}
                      </div>
                      <div className="addons-cell">
                        <button
                          key={addon.id}
                          value={addon.id}
                          onClick={() => newAddons(i, addon.id)}
                          className="next-button-table"
                          style={
                            productDetails[values.plan]
                              ? addon.id === "signal_alerts" &&
                                productDetails[values.plan].key ===
                                  "master_plan"
                                ? { display: "none" }
                                : values.addOns.includes(addon.id)
                                ? { backgroundColor: "#d33541" }
                                : { backgroundColor: "#75CE41" }
                              : undefined
                          }
                          data-testid={`toggleaddon-${addon.id}`}
                        >
                          {values.addOns.includes(addon.id) ? "Remove" : "Add"}
                        </button>
                        {productDetails[values.plan] ? (
                          <p
                            style={{
                              color: "white",
                              position: "relative",
                              top: "30px",
                            }}
                          >
                            {addon.id === "signal_alerts"
                              ? productDetails[values.plan].key ===
                                "master_plan"
                                ? "Included"
                                : ""
                              : ""}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <br />
            <br />
            <div
              style={{ textAlign: "center", marginTop: 50, marginBottom: 0 }}
            >
              Selected Plan:{" "}
              <span style={{ textTransform: "capitalize" }}>
                {values.plan.replace(/_/g, " ")}
              </span>{" "}
              (
              <span style={{ textTransform: "capitalize" }}>
                {values.frequency}
              </span>
              )
            </div>
            <div
              data-testid="addons-total"
              style={{ textAlign: "center", marginTop: 10, marginBottom: 0 }}
            >
              Add-On(s) Total: ${totalPrice}
            </div>
            <div
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginTop: 5,
                marginBottom: 15,
              }}
            />
            <br />
            <div
              style={{
                textAlign: "center",
                display: "block",
                marginBottom: "10px",
                width: "90%",
                margin: "0 auto 2rem",
              }}
            >
              <Button data-testid="button-next" onClick={onNext} fullWidth>
                Next
              </Button>
              <br />
              <Button onClick={onBack} variant="secondary" fullWidth>
                Back
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectAddOns;
